// extracted by mini-css-extract-plugin
export default {"recos":"a5-z","productCardOverride":"b5-z","rowHasBadge":"c5-z"};